module.exports = __webpack_public_path__ + "img/rgznjs-3-sm.58c4c32e.jpg";